import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Регистрация Service Worker только в production (в dev вызывает бесконечную перезагрузку)
const isProduction = process.env.NODE_ENV === 'production';
if (isProduction && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker registered successfully:', registration.scope);
        setInterval(() => {
          registration.update();
        }, 60000);
      })
      .catch((error) => {
        console.log('Service Worker registration failed:', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);